
const digest = '2a5725e54edb4a175766ca4e344f4699caa42be36d2e955863007001469d935d';
const classes = {"container":"_container_114bk_1","rowContainer":"_rowContainer_114bk_8","row":"_row_114bk_8"};
const css = `._container_114bk_1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
}

._rowContainer_114bk_8 {
  display: flex;
  flex-direction: column;
}

._row_114bk_8 {
  display: flex;
  gap: 5px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  